import {
  configureStore,
  combineReducers,
} from "@reduxjs/toolkit";

import addSlice from "./address/add-slice";
import cartSlice from "./cart/cart-slice";
import checkoutSlice from "./checkout/checkout-slice";
import orderSlice from "./order/order-slice";
import uiSlice from "./ui/ui-slice";
import variantSlice from "./variant/variant-slice";
import countrySlice from "./country/country-slice";

import { RESET_APP } from "./rootActions";

const appReducer = combineReducers({
  ui: uiSlice.reducer,
  cart: cartSlice.reducer,
  checkout: checkoutSlice.reducer,
  add: addSlice.reducer,
  order: orderSlice.reducer,
  variant: variantSlice.reducer,
  country: countrySlice.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_APP) {
    state = undefined;
  }

  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;